import {DashboardConstants} from "../redux_constants/dashboard.constant"

export const changeTotalNumberOfPages = (numPages) => ({
    type : DashboardConstants.CHANGE_TOTAL_NUMBER_OF_PAGES, 
    numPages: numPages
})

export const changeTotal = (total) => ({
    type : DashboardConstants.CHANGE_TOTAL_SLIDES, 
    total: total
})

export const closeDrawer = () => ({
    type: DashboardConstants.CLOSE_DRAWER
})

export const openDrawer = () => ({
    type: DashboardConstants.OPEN_DRAWER
})

export const addTagToTagList = (tag) => ({
    type : DashboardConstants.ADD_TAG, 
    tag: tag
})

export const addSlidesToPoller = (ids_to_poll) => ({
    type: DashboardConstants.ADD_TO_POLLER,
    ids_to_poll
})

export const clearAndAddSlidesToPoller = (ids_to_poll) => ({
    type: DashboardConstants.CLEAR_AND_ADD_TO_POLLER,
    ids_to_poll
})

export const clearPoller = (ids_to_poll) => ({
    type: DashboardConstants.CLEAR_POLLER,
})

export const removeSlidesFromPoller = (ids_to_remove) => ({
    type: DashboardConstants.REMOVE_FROM_POLLER,
    ids_to_remove
})